export const environment = {
    production: true,
    clientId: '5ac3c758-0183-44b9-b977-0113a57f8753',
    tenantId: '530b7624-5466-4aef-b425-4989a73f2217',
    redirectUrl: 'https://salestool.champrix.com'
};
